import * as React from 'react';
import { Field } from 'redux-form';

import KeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import { FormChipInput } from '@inqool/uas-web-core/es/components/controls/ChipInput';

import * as T from '@components/form/ChipInput/_chipInputTypes';

const defaultArrowStyle = (withLabel: boolean): React.CSSProperties => ({
  color: '#e1e0e1',
  position: 'absolute',
  right: 0,
  top: withLabel ? 36 : 15
});
const ChipInput: React.SFC<T.OutterProps & T.InnerProps> = props => (
  <div style={{ position: 'relative' }}>
    <FormChipInput {...props} fullWidth={true} floatingLabelText={props.label} />
    <KeyboardArrowDown style={...props.arrowstyle || defaultArrowStyle(!!props.label)} />
  </div>
);

export default ChipInput;

export class ChipInputField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/ChipInput/ChipInput.tsx